// let BASE_URL = 'http://192.168.1.132:30057'
// if (process.env.NODE_ENV === 'development') {
//   // 开发环境
//   BASE_URL = 'http://192.168.2.60:12135'
// } else {
//   // 生产环境
//   BASE_URL = 'http://152.136.185.210:5000'
// }
export const TIME_OUT = 60000
